import { defineStore } from 'pinia'
import axios from 'axios'
import { trackAddToCart } from '@/services/facebookAnalytics'

export const useCartStore = defineStore('cart', {
	state: () => ({
		items: [],
		shopifyCartId: null,
		merch: [],
		isMerchLoaded: false
	}),
	getters: {
		cartItemsTotal() {
			return this.items.length > 0
				? this.items
						.map((cI) => cI.quantity * parseFloat(cI.product.price))
						.reduce((a, c) => a + c, 0)
				: 0
		},
		availableMerch() {
			return this.merch
				.filter(
					(p) =>
						p.productType === 'Accesorio' &&
						p.variant &&
						p.variant.availableForSale &&
						!p.title.toLowerCase().includes('papel de regalo')
				)
				.sort((a, b) => a.title.localeCompare(b.title))
		}
	},
	persist: {
		storage: localStorage
	},
	actions: {
		getCartItems() {
			return this.items.length > 0
				? this.items.map((cI) => cI.quantity).reduce((a, c) => a + c, 0)
				: 0
		},
		clearCart() {
			this.items = []
			this.shopifyCartId = null
			return
		},
		getCartItem(product) {
			return this.items.length > 0 ? this.items.find((cI) => cI.product.id == product.id) : null
		},
		modifyCartItem(quantity, product) {
			console.log(quantity, product)
			let cartItem =
				this.items.length > 0 ? this.items.find((cI) => cI.product.id == product.id) : null

			if (!cartItem && quantity == 1) {
				this.items.push({
					quantity: 1,
					product: product
				})
				// Track AddToCart event
				trackAddToCart(product)
			} else if (!cartItem && quantity == -1) {
				return
			} else if (cartItem.quantity + quantity == 0) {
				this.items.splice(this.items.indexOf(cartItem), 1)
			} else {
				cartItem.quantity += quantity
			}
		},
		setShopifyCartId(cartId) {
			this.shopifyCartId = cartId
		},
		async fetchMerch() {
			if (this.isMerchLoaded) return

			try {
				const { data } = await axios.get('/api/shopify/products')
				this.merch = data.products
				this.isMerchLoaded = true
			} catch (error) {
				console.error('Error fetching merch:', error)
			}
		},
		async validateAndUpdateCartQuantities() {
			try {
				// Fetch all products to get current inventory
				const { data } = await axios.get('/api/shopify/products')
				const products = data.products

				// Create a map of product IDs to their current available quantities
				const availableQuantities = new Map(
					products.map((p) => [p.id, p.variant?.quantityAvailable || 0])
				)

				// Update cart items based on available quantities
				this.items = this.items.filter((item) => {
					const availableQty = availableQuantities.get(item.product.id) || 0

					if (availableQty === 0) {
						// Remove item if no quantity available
						return false
					} else if (item.quantity > availableQty) {
						// Update quantity if it exceeds available amount
						item.quantity = availableQty
						return true
					}
					return true
				})
			} catch (error) {
				console.error('Error validating cart quantities:', error)
			}
		}
	}
})
